shadow$provide[395] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 alignXYZW(vec4 xyzw) {
  return floor(xyzw + .5);
}

`;

};